import { useLanguages } from "src/providers"
import { useLocalStorage } from "../../utils/useLocalStorage"
import { Language } from "src/utils/useLanguageList"

export const useKmProps = () => {
  const { allUserLanguages, nativeLanguage, kmDefaultLang } = useLanguages()

  const languages = allUserLanguages

  const [lang, setLang] = useLocalStorage<Language>(
    "lang",
    kmDefaultLang,
    (value: Language) => languages.some((l) => l.languageId === value.languageId),
    [allUserLanguages, nativeLanguage]
  )

  return {
    languages,
    lang,
    setLang
  }
}
